import { connect } from 'react-redux';
import { Welcome } from '../../components';

const mapStateToProps = state => ({
  name: state.auth.user ? state.auth.user.name : 'guest'
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Welcome);



// WEBPACK FOOTER //
// ./src/containers/Welcome/Welcome.js